const _ = require("lodash");

const XP_PER_EQUATION = 2;

const settings = {
	updatePercentCompleteOnStateChange: true,
	canReplayProblem: true,
	starProgressType: "static",
	canSwitchSet: true,
};

const initialize = function(result, processor) {
	result.problems.forEach(p => {
		p.customState = _.extend(p.customState, {
			message: p.model.message,
			realMessage: p.model.realMessage,
			numEquations: p.model.equations.length,
		});
	});
};

//The backend needs the custom state of completed problems to compute trial xp, so this always saves customState
//(As opposed to normal results that only do so for problems without an outcome)
const computeBackendProgress = function(result, defaultProgress) {
	return _.extend({}, defaultProgress, {
		problems: result.problems.map(p =>
			_.pick(p, ["trials", "customState", "started", "outcome"])
		),
	});
};

const getPercentComplete = function(result) {
	let answered = 0;
	result.problems.forEach(p => {
		if (p.outcome) {
			answered += 1;
		}
	});
	return answered / result.problems.length;
};

const getStars = function(result) {
	return result.starsAvailable; //This game always gives you 3 stars
};

const getTrialXP = function(result) {
	const currentProblem = result.problems[result.currentProblemIndex || 0];
	const numEquations =
		(currentProblem.customState && currentProblem.customState.numEquations) ||
		1;
	return numEquations * XP_PER_EQUATION;
};

const getSetProgressInfo = function(result) {
	return {
		viewType: "standard",
		data: {},
	};
};

const getStarProgressInfo = function(result) {
	let isFinished = true;
	result.problems.forEach(p => {
		if (!p.outcome) {
			isFinished = false;
		}
	});
	return {
		styleType: result.styleType,
		filledAmount: getPercentComplete(result),
		totalAmount: 1,
		starsEarned: isFinished,
		starsAvailable: result.starsAvailable,
	};
};

const getResultProgressXP = function(backendResult) {
	const {progress} = backendResult;
	const numEquations = _.sum(
		_.map(progress.problems, p => _.get(p, "customState.numEquations", 0))
	);
	return numEquations * XP_PER_EQUATION;
};

module.exports = {
	initialize,
	settings,
	computeBackendProgress,
	getPercentComplete,
	getTrialXP,
	getSetProgressInfo,
	getStars,
	getStarProgressInfo,
	getResultProgressXP,
};
